// エキスポ会場での登録導線の目印（Trello #241）。
// オンボーディング画面の隠し操作で立て、投資力診断の結果画面で投資スタイル診断を飛ばすため、
// 起動時（src/WithAuth.tsx）にスタイル診断への強制遷移を外すために参照する。
//
// 恒久的な「診断の完了」はサーバー側の is_investment_style_diagnosis_complete が情報源であり、
// この目印はその未完了ユーザーをこの端末でだけ強制遷移から外す補助フラグ。サーバーの値は変えない。
//
// SMS の確認でメッセージアプリに切り替えている間にアプリが終了することがあり、sessionStorage だと
// その時点で消えて以後スタイル診断へ戻されてしまう（オンボーディング画面はログイン後は出ないので再発動もできない）。
// そのため localStorage に置き、ログアウト・ログイン画面の表示・診断完了の判明で明示的に消す。
//
// 目印を読む箇所（撤去時はまとめて外す）: src/WithAuth.tsx（起動時の強制遷移の除外）、
// src/pages/diagnosis/DiagnosisPage.tsx（次の遷移先・ステップ表示・案内文）、
// src/components/registration/RegistrationPhases.tsx と
// src/components/diagnosis/DiagnosisCompatibilityAgentsStepChips.tsx（飛ばすスタイル診断のチップを出さない）。
export const EXPO_REGISTRATION_STORAGE_KEY = "expo_registration";

const getLocalStorage = (): Storage | null => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    // Safari のプライベートブラウジング等でストレージアクセスが例外になるケースを握りつぶす
    return null;
  }
};

// 目印を立てる。保存できなかった（= 導線が成立しない）ときは false を返し、呼び出し側で案内に使う。
export const markExpoRegistration = (): boolean => {
  const storage = getLocalStorage();
  if (!storage) return false;
  try {
    storage.setItem(EXPO_REGISTRATION_STORAGE_KEY, "1");
    return true;
  } catch {
    return false;
  }
};

export const isExpoRegistration = (): boolean => {
  const storage = getLocalStorage();
  if (!storage) return false;
  try {
    return storage.getItem(EXPO_REGISTRATION_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const clearExpoRegistration = (): void => {
  const storage = getLocalStorage();
  if (!storage) return;
  try {
    storage.removeItem(EXPO_REGISTRATION_STORAGE_KEY);
  } catch {
    // 消せなくても通常導線の動作は変わらない（次の判定で読めなければ false 扱いになる）
  }
};
